var breakpoints = require("./breakpoints");
var constants = require("./constants");

var prevArrow = "<svg class='svg-inline icon-arrow-left' width='12' height='26' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M3.8855 10.0002L10.9428 2.94283C11.4628 2.42149 11.4628 1.57749 10.9428 1.05749C10.4228 0.537492 9.5775 0.536159 9.0575 1.05749L1.0575 9.05749C0.536171 9.57749 0.536171 10.4228 1.0575 10.9428L9.0575 18.9428C9.5775 19.4628 10.4228 19.4628 10.9428 18.9428C11.4628 18.4228 11.4628 17.5775 10.9428 17.0575L3.8855 10.0002Z' fill='#EB0203'/> </svg>";
var nextArrow = "<svg class='svg-inline icon-arrow-right' width='12' height='26' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M8.11484 9.99968L1.0575 17.057C0.536171 17.577 0.536171 18.4223 1.0575 18.9423C1.57884 19.4623 2.42284 19.4623 2.94284 18.9423L10.9428 10.9423C11.4628 10.4223 11.4628 9.57701 10.9428 9.05702L2.94284 1.05702C2.4215 0.535682 1.5775 0.535682 1.0575 1.05702C0.537504 1.57835 0.536171 2.42235 1.0575 2.94235L8.11484 9.99968Z' fill='#EB0203'/> </svg> ";

var styleguideConfig = {
    adaptiveHeight: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
        {
            breakpoint: breakpoints.values.desktopLarge,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false
            }
        },
        {
            breakpoint: breakpoints.values.desktop,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
            }
        },
        {
            breakpoint: breakpoints.values.tablet,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
            }
        }
    ]
};

var defaultConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow
};

var slickOnlyMobile = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: "8%",
    dots: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: breakpoints.values.tablet - 1,
            settings: "unslick"
        }
    ]
};

const brandPrevArrow = (brandID) => {
    return `<svg class="svg-inline ${brandID}-svgbg-icon-arrow-prev icon-arrow-left"></svg>`;
};

const brandNextArrow = (brandID) => {
    return `<svg class="svg-inline ${brandID}-svgbg-icon-arrow-next icon-arrow-right"></svg>`;
};

/**
 * @function
 * @description - Recommended Products from other Brands Slick carousel configuration
 * @param {Integer} itemsNumber - Recommended products items number
 * @param {String} brandID - id of the brand
 */
const productRecommendations = (itemsNumber, brandID) => {
    return {
        slidesToShow: 7,
        slidesToScroll: 7,
        dots: itemsNumber > 7 ? true : false,
        prevArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandPrevArrow(brandID) : prevArrow,
        nextArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandNextArrow(brandID) : nextArrow,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopLarge,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    dots: itemsNumber > 5 ? true : false
                }
            },
            {
                breakpoint: breakpoints.values.desktop,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: itemsNumber > 4 ? true : false,
                    arrows: false
                }
            },
            {
                breakpoint: breakpoints.values.tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: itemsNumber > 1 ? true : false,
                    arrows: false
                }
            }
        ]
    };
};

/**
 * @function
 * @description - Recommended Products from other Brands Slick large carousel configuration
 * @param {Integer} itemsNumber - Recommended products items number
 * @param {String} brandID - id of the brand
 */
const productRecommendationsLarge = (itemsNumber, brandID) => {
    return {
        slidesToShow: 7,
        slidesToScroll: 7,
        dots: itemsNumber > 7 ? true : false,
        prevArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandPrevArrow(brandID) : prevArrow,
        nextArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandNextArrow(brandID) : nextArrow,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopLarge,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    dots: itemsNumber > 5 ? true : false
                }
            },
            {
                breakpoint: breakpoints.values.desktop,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: itemsNumber > 4 ? true : false,
                    arrows: false
                }
            },
            {
                breakpoint: breakpoints.values.tablet,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: itemsNumber > 1 ? true : false,
                    arrows: false
                }
            }
        ]
    };
};

/**
 * @function
 * @description - Category tiles Slick carousel configuration
 * @param {Integer} itemsNumber - category tiles number
 * @param {String} brandID - id of the brand
 */
const categoryTiles = (itemsNumber, brandID) => {
    return {
        slidesToShow: 12,
        slidesToScroll: 12,
        infinite: false,
        prevArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandPrevArrow(brandID) : prevArrow,
        nextArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandNextArrow(brandID) : nextArrow,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopLarge,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8
                }
            },
            {
                breakpoint: breakpoints.values.desktop,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6
                }
            }
        ]
    };
};

/**
 * @function
 * @description - Cart coupons Slick carousel configuration
 * @param {Integer} itemsNumber - Coupon items number
 */
const couponsCarousel = itemsNumber => {
    return {
        dots: true,
        infinite: true,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopExtraLarge,
                settings: {
                    slidesToShow: itemsNumber < 4 ? itemsNumber : 4,
                    slidesToScroll: 4,
                    centerMode: false,
                }
            },
            {
                breakpoint: breakpoints.values.desktop - 1,
                settings: {
                    arrows: false,
                    slidesToShow: itemsNumber < 4 ? itemsNumber : 4.2,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoints.values.tablet - 1,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "15px"
                }
            }
        ]
    };
};

/*
* @function
* @description - Cart coupons Slick carousel configuration - Jquery
* @param {Integer} itemsNumber - Coupon items number
*/
const couponsCarouselJQuery = (itemsNumber, brandID) => {
    return {
        dots: true,
        infinite: true,
        prevArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandPrevArrow(brandID) : prevArrow,
        nextArrow: typeof brandID != "undefined" && brandID !== constants.BRAND_COL ? brandNextArrow(brandID) : nextArrow,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: breakpoints.values.desktop - 1,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoints.values.tablet,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "15px"
                }
            }
        ]
    };
};

/**
 * @function
 * @description - Cart alternative products Slick carousel configuration
 * @param {Integer} itemsNumber - Alternative products items number
 */
const alternativeProductsCarousel = itemsNumber => {
    return {
        dots: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopExtraLarge,
                settings: {
                    slidesToShow: itemsNumber < 4 ? itemsNumber : 4,
                    slidesToScroll: 4,
                    centerMode: false,
                }
            },
            {
                breakpoint: breakpoints.values.desktop - 1,
                settings: {
                    arrows: true,
                    slidesToShow: itemsNumber < 2 ? itemsNumber : 2,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoints.values.tablet - 1,
                settings: {
                    arrows: false,
                    slidesToShow: itemsNumber < 2 ? itemsNumber : 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 450 - 1,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    variableWidth: true,
                    adaptiveHeight: true
                }
            }
        ]
    };
};

/**
 * @function
 * @description - Checkout - delivery schedule slider configuration
 * @param {Integer} itemsNumber - Delivery slots items number
 */
const deliveryScheduleSlider = (itemsNumber, isNonScheduled, loadMoreSlots) => {
    const adjustedSlidesToShow = Math.min(itemsNumber, 6);
    const adjustedSlidesToScroll = Math.min(itemsNumber, 7);

    const initialSlide = loadMoreSlots ? typeof loadMoreSlots === "number" ? Math.floor((loadMoreSlots - 1) / adjustedSlidesToScroll) * adjustedSlidesToScroll : adjustedSlidesToScroll : 0;

    return {
        dots: false,
        slidesToShow: adjustedSlidesToShow,
        infinite: false,
        centerMode: false,
        autoplay: false,
        initialSlide: initialSlide,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopUltraWideLarge,
                settings: {
                    slidesToShow: itemsNumber <= 7 ? Math.max(itemsNumber - 1, 1) : 7,
                    swipeToSlide: false,
                    swipe: false,
                    slidesToScroll: adjustedSlidesToScroll
                }
            },
            {
                breakpoint: breakpoints.values.desktop - 1,
                settings: {
                    arrows: false,
                    swipeToSlide: true,
                    slidesToShow: itemsNumber <= 6 ? itemsNumber-0.5 : 5.5
                }
            },
            {
                breakpoint: breakpoints.values.tablet - 1,
                settings: isNonScheduled ? "unslick" : {
                    arrows: false,
                    swipeToSlide: true,
                    slidesToShow: itemsNumber <= 4 ? itemsNumber-0.5 : 3.5
                }
            }
        ]
    };
};

var pdpImages = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
        {
            breakpoint: breakpoints.values.desktopLarge,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true
            }
        },
        {
            breakpoint: breakpoints.values.desktop,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true
            }
        },
        {
            breakpoint: breakpoints.values.tablet,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true
            }
        }
    ]
};

var orderReviewShipments = {
    prevArrow: `<span class="review-order-prev-arrow" data-toggle="tooltip" data-placement="left">${prevArrow}</span>`,
    nextArrow: `<span class="review-order-next-arrow" data-toggle="tooltip" data-placement="right">${nextArrow}</span>`,
    appendArrows: $(".js-review-order-arrows"),
    draggable: false,
    infinite: false,
    swipe: false,
    touchMove: false,
    arrows: true
};

var checkoutStepShipments = {
    prevArrow: `<span class="shipment-prev-arrow" data-toggle="tooltip" data-placement="left">${prevArrow}</span>`,
    nextArrow: `<span class="shipment-next-arrow" data-toggle="tooltip" data-placement="right">${nextArrow}</span>`,
    appendArrows: $(".js-checkout-shippment-arrows"),
    draggable: false,
    infinite: false,
    adaptiveHeight: true,
    swipe: false,
    touchMove: false,
    arrows: true
};

/**
 * @function
 * @description - Click&Go banner Slick carousel configuration
 */
const clickgoBannerCarousel = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
        {
            breakpoint: breakpoints.values.desktopExtraLarge,
            settings: {
                arrows: true
            }
        },
        {
            breakpoint: breakpoints.values.desktop - 1,
            settings: {
                arrows: false
            }
        }
    ]
};

export {
    styleguideConfig,
    defaultConfig,
    productRecommendations,
    productRecommendationsLarge,
    categoryTiles,
    couponsCarousel,
    alternativeProductsCarousel,
    pdpImages,
    slickOnlyMobile,
    deliveryScheduleSlider,
    prevArrow,
    nextArrow,
    orderReviewShipments,
    checkoutStepShipments,
    clickgoBannerCarousel,
    couponsCarouselJQuery
};
